var render = function () {
  var _vm$work, _vm$work2, _vm$work3, _vm$work3$author, _vm$work4, _vm$work4$author, _vm$work5, _vm$work6, _vm$work6$author, _vm$work6$author$name, _vm$work7, _vm$work7$author, _vm$work7$author$name, _vm$work8, _vm$work8$author, _vm$work8$author$born, _vm$work8$author$born2, _vm$work8$author$born3, _vm$work8$author$born4, _vm$work8$author$born5, _vm$work9, _vm$work9$author, _vm$work9$author$coun, _vm$work10, _vm$work11, _vm$work12, _vm$work13, _vm$work14, _vm$work14$price_esti, _vm$work14$price_esti2, _vm$work14$price_esti3, _vm$work15, _vm$work15$price_esti, _vm$work15$price_esti2, _vm$work15$price_esti3, _vm$work16, _vm$work16$price_auct, _vm$work16$price_auct2, _vm$work16$price_auct3, _vm$work17, _vm$work17$price_auct, _vm$work17$price_auct2, _vm$work17$price_auct3, _vm$work18, _vm$work21, _vm$work22, _vm$work23, _vm$work23$author, _vm$work24, _vm$work24$author;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [!_vm.isLoaded ? [_c('v-sheet', {
    staticClass: "d-flex justify-center align-center"
  }, [_c('v-progress-circular', {
    staticClass: "my-60",
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": "5"
    }
  })], 1)] : _vm.work ? [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5",
      "xl": "7"
    }
  }, [_c('div', {
    staticClass: "pr-xl-14"
  }, [_c('auction-work-imgs', {
    attrs: {
      "imgs": (_vm$work = _vm.work) === null || _vm$work === void 0 ? void 0 : _vm$work.imgs
    }
  }), _c('div', {
    staticClass: "d-none d-md-block font-size-16 grey-68--text mt-100"
  }, [_c('div', {
    staticClass: "mb-12 mb-md-22"
  }, [_c('h5', {
    staticClass: "font-size-20 font-size-md-24 font-weight-medium font-notoserif primary--text mb-4"
  }, [_vm._v("작품정보")]), _c('v-divider', {
    staticClass: "primary"
  })], 1), _c('div', {
    staticClass: "pb-22 pb-md-44"
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s((_vm$work2 = _vm.work) === null || _vm$work2 === void 0 ? void 0 : _vm$work2.content)
    }
  }), _c('br'), ((_vm$work3 = _vm.work) === null || _vm$work3 === void 0 ? void 0 : (_vm$work3$author = _vm$work3.author) === null || _vm$work3$author === void 0 ? void 0 : _vm$work3$author.content) ? _c('p', {
    staticClass: "font-size-16 font-size-md-18 font-weight-bold primary--text mb-4"
  }, [_vm._v("작가설명")]) : _vm._e(), _c('div', {
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s((_vm$work4 = _vm.work) === null || _vm$work4 === void 0 ? void 0 : (_vm$work4$author = _vm$work4.author) === null || _vm$work4$author === void 0 ? void 0 : _vm$work4$author.content)
    }
  })]), _c('v-divider', {
    staticClass: "primary"
  })], 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "7",
      "xl": "5"
    }
  }, [_c('div', {
    staticClass: "pl-xl-44"
  }, [_c('div', {
    staticClass: "primary--text"
  }, [_c('div', [_c('div', {
    staticClass: "d-flex justify-space-between"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16 font-weight-bold"
  }, [_vm._v("LOT. " + _vm._s((_vm$work5 = _vm.work) === null || _vm$work5 === void 0 ? void 0 : _vm$work5.lot))]), _c('v-spacer'), _c('auction-work-navigation', _vm._b({}, 'auction-work-navigation', {
    work: _vm.work
  }, false))], 1), _c('div', {
    staticClass: "mt-16 mt-md-26"
  }, [_c('strong', {
    staticClass: "font-size-22 font-size-md-32 font-weight-medium font-notoserif"
  }, [_vm._v(_vm._s((_vm$work6 = _vm.work) === null || _vm$work6 === void 0 ? void 0 : (_vm$work6$author = _vm$work6.author) === null || _vm$work6$author === void 0 ? void 0 : (_vm$work6$author$name = _vm$work6$author.name) === null || _vm$work6$author$name === void 0 ? void 0 : _vm$work6$author$name.ko))]), _c('span', {
    staticClass: "font-size-14 font-weight-light grey-68--text pl-8 pl-md-10"
  }, [_vm._v(_vm._s((_vm$work7 = _vm.work) === null || _vm$work7 === void 0 ? void 0 : (_vm$work7$author = _vm$work7.author) === null || _vm$work7$author === void 0 ? void 0 : (_vm$work7$author$name = _vm$work7$author.name) === null || _vm$work7$author$name === void 0 ? void 0 : _vm$work7$author$name.en))]), _c('span', {
    staticClass: "font-size-14 font-weight-light grey-68--text pl-8 pl-md-10"
  }, [_vm._v("b. " + _vm._s((_vm$work8 = _vm.work) === null || _vm$work8 === void 0 ? void 0 : (_vm$work8$author = _vm$work8.author) === null || _vm$work8$author === void 0 ? void 0 : (_vm$work8$author$born = _vm$work8$author.bornAt) === null || _vm$work8$author$born === void 0 ? void 0 : (_vm$work8$author$born2 = _vm$work8$author$born.toDate) === null || _vm$work8$author$born2 === void 0 ? void 0 : (_vm$work8$author$born3 = _vm$work8$author$born2.call(_vm$work8$author$born)) === null || _vm$work8$author$born3 === void 0 ? void 0 : (_vm$work8$author$born4 = _vm$work8$author$born3.split) === null || _vm$work8$author$born4 === void 0 ? void 0 : (_vm$work8$author$born5 = _vm$work8$author$born4.call(_vm$work8$author$born3, "-")) === null || _vm$work8$author$born5 === void 0 ? void 0 : _vm$work8$author$born5[0]))]), _c('span', {
    staticClass: "font-size-14 font-weight-light grey-68--text pl-8 pl-md-10"
  }, [_vm._v(_vm._s((_vm$work9 = _vm.work) === null || _vm$work9 === void 0 ? void 0 : (_vm$work9$author = _vm$work9.author) === null || _vm$work9$author === void 0 ? void 0 : (_vm$work9$author$coun = _vm$work9$author.country) === null || _vm$work9$author$coun === void 0 ? void 0 : _vm$work9$author$coun.en))])]), _c('div', {
    staticClass: "mt-8 mt-md-12"
  }, [_c('span', {
    staticClass: "tit tit--sm font-notoserif"
  }, [_vm._v(_vm._s((_vm$work10 = _vm.work) === null || _vm$work10 === void 0 ? void 0 : _vm$work10.subject))])]), _c('div', {
    staticClass: "mt-2 mt-md-4"
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-16 grey-68--text"
  }, [_vm._v(_vm._s((_vm$work11 = _vm.work) === null || _vm$work11 === void 0 ? void 0 : _vm$work11.year) + " ㅣ " + _vm._s((_vm$work12 = _vm.work) === null || _vm$work12 === void 0 ? void 0 : _vm$work12.material) + " ㅣ " + _vm._s((_vm$work13 = _vm.work) === null || _vm$work13 === void 0 ? void 0 : _vm$work13.dimensionCodeTag))])])]), _vm.isProgram ? [_c('v-divider', {
    staticClass: "grey-da mt-20 mt-md-34"
  }), _c('div', {
    staticClass: "font-size-14 font-size-lg-16 py-12 py-md-18"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('span', [_vm._v("추정가")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v("KRW " + _vm._s((_vm$work14 = _vm.work) === null || _vm$work14 === void 0 ? void 0 : (_vm$work14$price_esti = _vm$work14.price_estimated) === null || _vm$work14$price_esti === void 0 ? void 0 : (_vm$work14$price_esti2 = _vm$work14$price_esti.from) === null || _vm$work14$price_esti2 === void 0 ? void 0 : (_vm$work14$price_esti3 = _vm$work14$price_esti2.format) === null || _vm$work14$price_esti3 === void 0 ? void 0 : _vm$work14$price_esti3.call(_vm$work14$price_esti2)) + " ~ " + _vm._s((_vm$work15 = _vm.work) === null || _vm$work15 === void 0 ? void 0 : (_vm$work15$price_esti = _vm$work15.price_estimated) === null || _vm$work15$price_esti === void 0 ? void 0 : (_vm$work15$price_esti2 = _vm$work15$price_esti.to) === null || _vm$work15$price_esti2 === void 0 ? void 0 : (_vm$work15$price_esti3 = _vm$work15$price_esti2.format) === null || _vm$work15$price_esti3 === void 0 ? void 0 : _vm$work15$price_esti3.call(_vm$work15$price_esti2)))])])], 1), _c('v-row', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('span', [_vm._v("시작가")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v("KRW " + _vm._s((_vm$work16 = _vm.work) === null || _vm$work16 === void 0 ? void 0 : (_vm$work16$price_auct = _vm$work16.price_auction) === null || _vm$work16$price_auct === void 0 ? void 0 : (_vm$work16$price_auct2 = _vm$work16$price_auct.from) === null || _vm$work16$price_auct2 === void 0 ? void 0 : (_vm$work16$price_auct3 = _vm$work16$price_auct2.format) === null || _vm$work16$price_auct3 === void 0 ? void 0 : _vm$work16$price_auct3.call(_vm$work16$price_auct2)))])])], 1), _c('v-row', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('span', [_vm._v("현재가")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v("KRW " + _vm._s((_vm$work17 = _vm.work) === null || _vm$work17 === void 0 ? void 0 : (_vm$work17$price_auct = _vm$work17.price_auction) === null || _vm$work17$price_auct === void 0 ? void 0 : (_vm$work17$price_auct2 = _vm$work17$price_auct.current) === null || _vm$work17$price_auct2 === void 0 ? void 0 : (_vm$work17$price_auct3 = _vm$work17$price_auct2.format) === null || _vm$work17$price_auct3 === void 0 ? void 0 : _vm$work17$price_auct3.call(_vm$work17$price_auct2)))])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-da"
  }), _c('div', {
    staticClass: "font-size-14 font-size-lg-16 py-12 py-md-18"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('span', [_vm._v("응찰횟수")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-center"
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12 pr-10 pr-lg-18"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s((((_vm$work18 = _vm.work) === null || _vm$work18 === void 0 ? void 0 : _vm$work18._bids) || []).length))]), _vm._v(" 회 ")]), _c('auction-bids', {
    attrs: {
      "bids": _vm.bids
    },
    on: {
      "refresh": function refresh($event) {
        return _vm.init(true);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "outlined": "",
            "small": "",
            "height": "26",
            "color": "grey-cb"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "primary--text"
        }, [_vm._v("응찰기록보기")])])];
      }
    }], null, false, 1423057875)
  })], 1)])], 1), _c('v-row', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('span', [_vm._v("응찰기간")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v(_vm._s(_vm.duration_auction))])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-da"
  }), _c('div', {
    staticClass: "font-size-14 font-size-lg-16 py-12 py-md-18"
  }, [_c('v-row', {
    staticClass: "font-weight-medium",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('span', [_vm._v("남은시간")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('div', {
    staticClass: "pl-sm-12"
  }, [_c('auction-work-until', {
    attrs: {
      "work": _vm.work
    }
  })], 1)])], 1)], 1), _c('v-divider', {
    staticClass: "primary"
  }), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('auction-commission', {
    attrs: {
      "work": _vm.work
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
            on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "large": "",
            "block": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v("낙찰 수수료"), _c('i', {
          staticClass: "icon icon-help-circle-outline ml-6 ml-md-8"
        })])];
      }
    }], null, false, 290693231)
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "h-100 py-6"
  }, [_c('v-divider', {
    staticClass: "primary",
    attrs: {
      "vertical": ""
    }
  })], 1)]), _c('v-col', [_c('auction-units', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var attrs = _ref3.attrs,
            on = _ref3.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "large": "",
            "block": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v("경매 호가표"), _c('i', {
          staticClass: "icon icon-help-circle-outline ml-6 ml-md-8"
        })])];
      }
    }], null, false, 2523777015)
  })], 1)], 1), _c('v-divider', {
    staticClass: "primary"
  }), _c('div', {
    staticClass: "mt-16 mt-md-20"
  }, [_c('auction-actions', _vm._b({
    on: {
      "refresh": function refresh($event) {
        return _vm.init(true);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var _vm$work19, _vm$work20;

        var attrs = _ref4.attrs,
            on = _ref4.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "block": "",
            "x-large": "",
            "color": "primary",
            "disabled": (_vm$work19 = _vm.work) === null || _vm$work19 === void 0 ? void 0 : _vm$work19.isAuctionEnded
          }
        }, 'v-btn', attrs, false), on), [((_vm$work20 = _vm.work) === null || _vm$work20 === void 0 ? void 0 : _vm$work20.isAuctionEnded) ? [_vm._v("경매종료")] : [_vm._v("응찰하기")]], 2)];
      }
    }], null, false, 1095115076)
  }, 'auction-actions', {
    work: _vm.work,
    bids: _vm.bids
  }, false))], 1)] : _vm._e(), _c('div', {
    staticClass: "mt-20 mt-md-40"
  }, [_c('v-divider', {
    staticClass: "grey-da"
  }), _c('auction-work-classifications', {
    attrs: {
      "classifications": (_vm$work21 = _vm.work) === null || _vm$work21 === void 0 ? void 0 : _vm$work21.classifications
    }
  }), _c('v-divider', {
    staticClass: "grey-da"
  })], 1), _vm.isPrivate ? [_c('div', {
    staticClass: "mt-20 mt-md-40"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "x-large": "",
      "color": "primary",
      "to": "/form/private-sale?_work=".concat(_vm.work._id)
    }
  }, [_vm._v("문의하기")])], 1)] : _vm._e()], 2)])]), _c('v-col', {
    staticClass: "d-md-none",
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "font-size-16 grey-68--text mt-10"
  }, [_c('div', {
    staticClass: "mb-12 mb-md-22"
  }, [_c('h5', {
    staticClass: "font-size-20 font-size-md-24 font-weight-medium font-notoserif primary--text mb-4"
  }, [_vm._v("작품정보")]), _c('v-divider', {
    staticClass: "primary"
  })], 1), _c('div', {
    staticClass: "pb-22 pb-md-44"
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s((_vm$work22 = _vm.work) === null || _vm$work22 === void 0 ? void 0 : _vm$work22.content)
    }
  }), _c('br'), ((_vm$work23 = _vm.work) === null || _vm$work23 === void 0 ? void 0 : (_vm$work23$author = _vm$work23.author) === null || _vm$work23$author === void 0 ? void 0 : _vm$work23$author.content) ? _c('p', {
    staticClass: "font-size-16 font-size-md-18 font-weight-bold primary--text mb-4"
  }, [_vm._v("작가설명")]) : _vm._e(), _c('div', {
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s((_vm$work24 = _vm.work) === null || _vm$work24 === void 0 ? void 0 : (_vm$work24$author = _vm$work24.author) === null || _vm$work24$author === void 0 ? void 0 : _vm$work24$author.content)
    }
  })]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])], 1)], 1)] : [_c('v-container', [_c('div', {
    staticClass: "tit tit--sm text-center pt-80"
  }, [_vm._v("데이터가 없습니다.")])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }